import {combineReducers} from 'redux'
import requestStateReducer from 'lib/reducers/requestStateReducer'
import {expensesTypes} from 'actions/types'

const reducer = combineReducers({
  requestState: requestStateReducer(expensesTypes.FETCH_DEFAULT_CALCULATOR_VALUES)
})

export default reducer
